import React, { useContext } from 'react';
import { Box, CustomModalLayout, Modal } from '@wix/design-system';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { AppContextProvider } from '../../AppLoader';

// WebAuthn in a cross-origin iframe needs the embedder to delegate these.
const STEP_UP_IFRAME_ALLOW =
  'publickey-credentials-get; publickey-credentials-create';

// Hosts oauth2ng's /authorize iframe when the silent step-up needs the user. ESC / X
// cancels.
export const StepUpModal: React.FC = observer(() => {
  const { rootStore } = useContext(AppContextProvider);
  const { stepUpModalStore } = rootStore;
  const { t } = useTranslation();
  const title = t('passkey.stepUp.modal.title', 'Account verification');
  const handleClose = () => stepUpModalStore.requestCancel();

  return (
    <Modal
      isOpen={stepUpModalStore.isOpen}
      onRequestClose={handleClose}
      contentLabel={title}
      dataHook="step-up-modal"
    >
      <CustomModalLayout
        title={title}
        onCloseButtonClick={handleClose}
        width="600px"
        content={
          <Box height="520px" width="100%">
            {stepUpModalStore.url && (
              <iframe
                title={title}
                data-hook="step-up-modal-iframe"
                src={stepUpModalStore.url}
                allow={STEP_UP_IFRAME_ALLOW}
                style={{ width: '100%', height: '100%', border: 0 }}
              />
            )}
          </Box>
        }
      />
    </Modal>
  );
});
